import { VStack } from '@sgme/ui';
import { Modal } from 'react-bootstrap';

export const ExpiredSessionModal = () => {
  function reload() {
    window.location.reload();
  }
  return (
    <Modal show backdrop="static" contentClassName="border border-danger">
      <Modal.Header>
        <VStack>
          <div
            className="d-flex align-items-center justify-content-center bg-danger bg-opacity-10 rounded-circle mb-4"
            style={{ width: 48, height: 48 }}
          >
            <i className="icon icon-md text-danger">power_off</i>
          </div>
          <h4 className="text-danger">Your session has expired</h4>
        </VStack>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-16px">
        <p className="text-secondary">We noticed that you have been inactive for while.</p>
        <p>
          For security reason, your connection times out after a period of inactivity. To keep working, reload the page
          or click Continue.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-primary" onClick={reload}>
          Continue
        </button>
      </Modal.Footer>
    </Modal>
  );
};
